import PropTypes from 'prop-types';
import { Link } from 'react-router';

import { PERM } from '#/config/permissions';
import { ROUTES } from '#/config/routes';
import { Button } from '#/modules/commonComponents/button';
import { useCan } from '#/modules/infra/auth/useCan';

const PurchaseOrderHubHeader = ({ page }) => {
  const canReadMaterial = useCan(PERM.PURCHASE_ORDER_READ);
  const canReadNonStock = useCan(PERM.MISC_PURCHASE_ORDER_READ);
  const isMaterial = page === 'material';
  const title = isMaterial ? '物料採購單列表' : '非庫存採購單';
  const switchItem = isMaterial
    ? {
      label: '非庫存採購單',
      to: ROUTES.miscPurchaseOrder,
      visible: canReadNonStock,
    }
    : {
      label: '物料採購單',
      to: ROUTES.purchaseOrder,
      visible: canReadMaterial,
    };

  return (
    <h1 className="page_title flex shrink-0 flex-wrap items-center gap-2">
      <span className="border-l-5 border-primary-400 pl-2.5">{title}</span>
      {switchItem.visible ? (
        <Button type="button" asChild>
          <Link to={switchItem.to}>{switchItem.label}</Link>
        </Button>
      ) : null}
    </h1>
  );
};

PurchaseOrderHubHeader.propTypes = {
  page: PropTypes.oneOf(['material', 'nonStock']).isRequired,
};

export default PurchaseOrderHubHeader;
